import Handlebars from 'handlebars';
const compileHandlebarTemplate = (template, data) => {
  const compiledTemplate = Handlebars.compile(template);
  return compiledTemplate(data);
};
export default compileHandlebarTemplate;
//# sourceMappingURL=compile-handlebar-template.js.map